<template>
    <div id="masterComponent" ref="masterComponent" class="w-100 d-flex flex-wrap justify-content-center align-items-start align-content-start p-0 my-0" :class="{'no-scrollbar': !hasScrollbar}">
        <template v-if="!viewFinal">
            <modal-o-k :active="false" :mess="mess" :title="successTitle" :showIncrement="modalSuccess" :lang="lang" :button="successButton" :successEvent="successEvent" @returnEvent="returnEvent"></modal-o-k>
            <modal-err :active="false" :mess="mess" :title="errorTitle" :showIncrement="modalError" :lang="lang"></modal-err>
            <loader :active="loading"></loader>
            <div class="w-100 d-flex flex-xl-wrap justify-content-start align-items-stretch align-content-stretch px-3 px-sm-4 px-xl-5 py-4 headerSpace mb-0">
                <img :src="logo" class="pe-none resizeHeight">
                <div class="flex-fill font-1-1 t-28 t-sm-23 t-xl-20 t-xxl-14 label-1 text-start ps-3 ps-xl-5 align-items-center align-content-center d-flex">
                    <span class="ps-sm-2 p-md-4">{{steps[selectedComponent].title}}</span>
                </div>
            </div>
            <div class="col-12 col-xl-10 col-xxl-8 d-flex flex-wrap mb-5">
                <div class="col-xl-6 col-12 d-flex flex-wrap justify-content-center align-content-start align-items-start"> 
                    <transition name="slide-fade" @before-leave="handleBeforeLeave" @leave="handleLeave" @before-enter="handleBeforeEnter" @enter="handleEnter">
                        <div class="col-xxl-8 col-10 text-start t-24 t-sm-18 t-md-24 lh-1 t-xl-12 t-xxl-9 label-1-1 mb-4" v-if="steps[selectedComponent].index == 0">
                            Elige un Diseño
                        </div>
                    </transition>

                    <transition name="gird" mode="out-in">
                        <div class="w-100 d-flex flex-wrap justify-content-center align-content-start align-items-start" v-if="steps[selectedComponent].index <= 2">
                            <design-list :formFields="form" @setViewIndex="setViewIndex" :viewSelector="steps[selectedComponent].index == 0"></design-list>
                        </div>
                        <div class="co-xl-12 col-11 d-flex justify-content-center align-content-start align-items-start" v-else-if="!(steps[selectedComponent].index === 4 && mobile)">
                            <whats-app-view :formFields="form"></whats-app-view>
                        </div>
                    </transition>

                    <div class="w-100 d-flex justify-content-center align-content-start align-items-start my-4 mt-sm-4 mb-sm-4 mb-xl-0 predHidden" :class="steps[selectedComponent].index != 0 ? 'showed' : ''" v-if="steps[selectedComponent].index != 0">
                        <span @click="setProgress(steps[selectedComponent].returnIndex)" class="t-16 t-sm-10 t-xl-5 t-xxl-3 font-2-1 linkChange">{{steps[selectedComponent].returnText}}</span>
                    </div>
                </div>
                <transition name="fade" mode="out-in">
                    <component :is="comp" :con="con" :lang="lang" :formFields="form" @setData="setForm" @progress="setProgress" @showModal="setModalMessage" @setLoading="setLoading" @sendOrder="sendOrder" :cities="cities"></component>
                </transition>
            </div>
        </template>
        <template v-else>
            <StepFormFinal :formFields="form" :logo="logo" :cities="cities" @reset="reset()"></StepFormFinal>
        </template>
    </div>
</template>

<script>
// @ is an alias to /src
import designList from '@/components/designList.vue'
import whatsAppView from '@/components/whatsAppView.vue'

import StepForm1 from '@/components/StepForm1.vue'
import StepForm2 from '@/components/StepForm2.vue'
import StepForm3 from '@/components/StepForm3.vue'
import StepForm4 from '@/components/StepForm4.vue'
import StepForm5 from '@/components/StepForm5.vue'
import StepForm6 from '@/components/StepForm6.vue'
import StepForm7 from '@/components/StepForm7.vue'
import StepFormFinal from '@/components/StepFormFinal.vue'
import loader from "@/components/common/loader.vue";
import modalOK from "@/components/common/successModal.vue";
import modalErr from "@/components/common/errorModal.vue";

export default {
    name: 'GiftCards',
    props:{
        lang:{
            default:"es",
            type: String
        },
        con:{
            default:{},
            type: Object
        }
    },
    components: {
        StepForm1,
        StepForm2,
        StepForm3,
        StepForm4,
        StepForm5,
        StepForm6,
        StepForm7,
        StepFormFinal,
        designList,
        loader,
        modalOK,
        whatsAppView,
        modalErr
    },
    watch: {
        comp() {
                this.$nextTick(() => {
                    this.checkScrollbar(); // Recalcula después de renderizar el nuevo componente
                });
            },
        },
    computed: {
		comp() {
            return this.steps[this.selectedComponent].component;
		}
	},
    methods:{
        reset(){
            this.selectedComponent = 0;
            this.viewFinal = false;
            this.form = {
                step1:{
                    amount:{id:'', value:0},
                    receiverName:'',
                    designId:''
                },
                step2:{
                    receiverWhatsapp:'',
                    receiverMessage:''
                },
                step3:{
                    sendDate:'now',
                    receiverDate:{date:''}
                },
                step4:{
                    senderName:'',
                    senderWhatsapp:'',
                    payForm:'online'
                },
                step5:{
                    lastPhoneCodeSended:'',
                    phoneConfirmed:'',
                    timer:0
                },
                step6:{
                    payConcreted:false,
                    payID:null
                },
                step7:{
                    cityName:'',
                    cityIndex:'',
                    storeId:'',
                    payForm:'cash'
                },

            }
        },
        handleBeforeLeave(el) {
            // Opcional: Añade un estilo inicial antes de la transición
            el.style.transition = "none";
        },
        handleLeave(el) {
            // Limpia cualquier estilo aplicado manualmente después de la transición
            el.style.transition = "";
        },
        handleBeforeEnter(el) {
      // Configura el estado inicial si es necesario antes de que se aplique el CSS
      el.style.height = "0";
      el.style.opacity = "0";
    },
    handleEnter(el) {
      // Limpia los estilos inline para que tome los valores de la transición CSS
      el.style.height = "";
      el.style.opacity = "";
    },
        getCities(){
            this.con.getCities().then((res)=>{
                this.cities = res.data;
            }).catch((err)=>{
                console.log(err);
            });
        },
        returnEvent(evetnID){
            switch(evetnID){
                case 1:
                    this.viewFinal = true;
                    break;
            }
        },
        setForm(form, step){
            this.form[step] = form;
        },
        setProgress(step){
            this.selectedComponent = step;
        },
        setModalMessage(data){
            switch(data.type){
                case 'error':
                    this.setModalError(data);
                    break;
                case 'success':
                    this.setModalSuccess(data);
                    break;
            }
        },
        setLoading(value){
            this.loading = value;
        },
        setModalError(data){
            this.errorTitle = data.title;
            this.mess = data.message;
            this.modalError += 1;
        },
        setModalSuccess(data){
            this.successTitle = data.title;
            this.mess = data.message;
            this.modalSuccess += 1;
            this.successEvent = 1;
        },
        sendOrder(){

            let order = {
                "orden": {
                    "payment": "",
                    "paymentType": "",
                    "transactionID": "",
                    "sent_at": (new Date(this.form.step3.receiverDate.date)).toLocaleString("en-CA", { hour12: false, day: '2-digit', month: '2-digit', year: 'numeric'}),
                    "storeNumber": '',
                    "change": 0,
                    "coupon": "",
                    "deliveryType": "takeout",
                    "deliveryName": this.capitalizeWords(this.form.step4.senderName),
                    "deliverPhone": this.form.step4.senderWhatsapp,
                    "deliveryComment": this.form.step2.receiverMessage,
                    "deliveryClientReceiver": this.capitalizeWords(this.form.step1.receiverName),
                    "deliveryPhoneReceiver": this.form.step2.receiverWhatsapp,
                    "products": {
                        "cards": [
                            {
                                "id": this.form.step1.amount.id,
                                "options": {
                                    ["GIFT CARD $"+this.form.step1.amount.value]: {
                                        "info": {
                                            "idReference": this.form.step1.amount.id,
                                            "selected": 1
                                        },
                                        "options": [
                                            {
                                                "COMMENT": {
                                                    "info": {
                                                        "idReference": "699",
                                                        "description": this.form.step1.designId,
                                                        "selected": 1
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                "quantity": 1
                            }
                        ]
                    }
                }
            };

            if(this.form.step4.payForm === 'online'){
                if(!this.form.step6.payConcreted){
                    this.setLoading(false);
                    this.$emit('showModal', {type:'error', message:'El pago online no se registro, te recomendamos comunicarte con la sucursal si no es el caso', title:'Pago no registrado'});
                    return;
                }else{
                    order.orden.payment = 13;
                    order.orden.paymentType = 'stripe';
                    order.orden.transactionID = this.form.step6.payID;
                    order.orden.storeNumber = 6001;
                }
            }else{
                order.orden.payment = 13;
                order.orden.paymentType = this.form.step7.payForm;
                order.orden.transactionID = '';
                order.orden.storeNumber = this.form.step7.storeId;
            }

            this.con.sendOrder(
                {
                    token: this.con.defToken,
                    data: order
                }
            ).then((res)=>{
                if(res.hasOwnProperty('currentStore')){
                    if(res.currentStore.open == 1){
                        this.setModalSuccess({title:'Giftcard adquirida con éxito', message:'El contenido será enviado el: ' + order.orden.sent_at});
                        this.loading = false;
                        return true;
                    }
                }
                this.setModalError({title:'Error', message:'Ha ocurrido un error al enviar tu orden'});
                this.loading = false;
            }).catch((err)=>{
                console.log(err);
                this.setModalError({title:'Error', message:'Ha ocurrido un error al enviar tu orden'});
                this.loading = false;
            });
        },
        setViewIndex(index){
            this.form.step1.designId = index;
        },
        checkScrollbar() {
            if(!this.mobile){
                this.hasScrollbar = this.$refs.masterComponent.scrollHeight > this.$refs.masterComponent.clientHeight;
            }
        },
    },
    mounted(){
        /*setTimeout(()=>{
            this.setModalSuccess({title:'Giftcard adquirida con éxito', message:'El contenido será enviado el: '});
            //this.viewFinal = true;
        }, 3000)*/
        this.getCities();
        this.checkScrollbar();
        this.mutationObserver = new MutationObserver(() => {
            this.checkScrollbar(); // Recalcular al detectar cambios en el DOM
        })
        this.mutationObserver.observe(this.$el, {
      childList: true, // Detecta cambios en los hijos directos
      subtree: true, // Detecta cambios en todos los descendientes
    });
        window.addEventListener('resize', this.checkScrollbar);
    },
    beforeDestroy() {
        if (this.mutationObserver) {
        this.mutationObserver.disconnect(); // Detener el observador
        }
        window.removeEventListener("resize", this.checkScrollbar);
    },
    data() {
        return {
            viewFinal:false,
            mutationObserver: null,
            hasScrollbar:true,
            loading:false,
            cities:[],
            steps:[
                {title:'Regala una Gift Card', component:'step-form-1', index:0, returnText:'', returnIndex:0},
                {title:'Personaliza tu Giftcard', component:'step-form-2', index:1, returnText:'ELEGIR DISEÑO Y NOMBRE', returnIndex:0},
                {title:'Fecha de envio', component:'step-form-3', index:2, returnText:'EDITAR NUMERO DE DESTINATARIO', returnIndex:1},
                {title:'Pago y Remitente', component:'step-form-4', index:3, returnText:'EDITAR FECHA DE ENVIO', returnIndex:2},
                {title:'Confirma tu número', component:'step-form-5', index:4, returnText:'EDITAR MI NUMERO', returnIndex:3},
                {title:'Pagar', component:'step-form-6', index:5, returnText:'EDITAR FORMA DE PAGO', returnIndex:3},
                {title:'Información de Pago', component:'step-form-7', index:6, returnText:'EDITAR FORMA DE PAGO', returnIndex:3},
            ],
            mobile: window.innerWidth < 1200,
            selectedComponent:0,
            logo: require('@/assets/images/franchise/bpt/logo.svg'),
            form:{
                step1:{
                    amount:{id:'', value:0},
                    receiverName:'',
                    designId:''
                },
                step2:{
                    receiverWhatsapp:'',
                    receiverMessage:''
                },
                step3:{
                    sendDate:'now',
                    receiverDate:{date:''}
                },
                step4:{
                    senderName:'',
                    senderWhatsapp:'',
                    payForm:'online'
                },
                step5:{
                    lastPhoneCodeSended:'',
                    phoneConfirmed:'',
                    timer:0
                },
                step6:{
                    payConcreted:false,
                    payID:null
                },
                step7:{
                    cityName:'',
                    cityIndex:'',
                    storeId:'',
                    payForm:'cash'
                },

            },

            /*modales*/
            mess:'',
            successTitle:"",
            modalSuccess:0,
            successEvent:0,
            successButton:'OK',
            errorTitle:"",
            modalError:0,
        }
    }
}
</script>
<style lang="css" scoped>
    #masterComponent {
        height: 100vh;
        overflow-y: scroll;
        overflow-x: hidden;
        /*transition: all 0.2s ease;*/
    }
    .resizeHeight{
        height: 100%;
        max-height: 50px;
        object-fit: contain;
    }
    .headerSpace{
        min-height: 100px;
        max-height: 100px;
    }
    .label-1{
        line-height: 1;
        font-weight: 500;
        color:var(--secondaryText)
    }
    .label-1-1{
        line-height: 2;
        font-weight: 700;
        color:var(--secondaryText)
    }
    @media (min-width: 768px) {
        .headerSpace{
            min-height: 180px;
            max-height: 180px;
        }
        .resizeHeight{
            max-height: 120px;
        }
    }
       .slide-fade-leave-active {
        transition: all .2s ease; /* Animación suave */
      }
      .slide-fade-enter-active {
        transition: all .2s ease; /* Animación suave */
      }
      
      .slide-fade-leave-to {
        height: 0; /* Mueve el segundo div hacia arriba */
        opacity: 0; /* Opcional para desvanecer */
      }

      .slide-fade-enter-from {
        height: 0; /* Altura inicial */
        opacity: 0; /* Totalmente invisible */
      }

      .slide-fade-enter-to {
        height: auto; /* Altura completa */
        opacity: 1; /* Totalmente visible */
      }



      .predHidden{
        height: 0;

      }.showed{
        animation:.2s increasein ease forwards;
        animation-delay: .2s;
      }

      

      /* Clases para la transición de salida */
        .fade-leave-active {
            transition: opacity 0.1s ease; /* Duración de la animación de salida */
        }

        .fade-leave-from {
            height: 0;
        }
        
        .fade-leave-to {
            height: 0;
            opacity: 0; /* Totalmente invisible al salir */
        }
        
        /* Clases para la transición de entrada */
        .fade-enter-active {
            transition: opacity 0.1s ease; /* Duración de la animación de entrada */
            transition-delay: 0.1s; /* Comienza después de que termina la salida */
        }
        
        .fade-enter-from {
            opacity: 0; /* Invisible al entrar */
            height: 0;
        }
        
        .fade-enter-to {
            opacity: 1; /* Totalmente visible */
        }


        /* Animación de salida */
  .gird-leave-active {
    transition: transform 0.3s ease, opacity 0.3s ease; /* Duración de 0.6s */
  }
  
  .gird-leave-from {
    transform: rotateY(0); /* Estado inicial */
    opacity: 1; /* Totalmente visible */
  }
  
  .gird-leave-to {
    transform: rotateY(-180deg); /* Gira hacia atrás */
    opacity: 0; /* Se desvanece */
  }
  
  /* Animación de entrada */
  .gird-enter-active {
    transition: transform 0.3s ease, opacity 0.3s ease; /* Duración de 0.6s */
    transition-delay: 0s; /* Comienza después de que termine la salida */
  }
  
  .gird-enter-from {
    transform: rotateY(180deg); /* Aparece desde atrás */
    opacity: 0; /* Invisible inicialmente */
  }
  
  .gird-enter-to {
    transform: rotateY(0); /* Gira hacia adelante */
    opacity: 1; /* Totalmente visible */
  }



.linkChange {
  background-color: #f8f9fa;
  border: 1px solid #dadce0;
  border-radius: 4px;
  cursor: pointer;
  height: auto;
  min-width: 54px;
  padding: 5px 10px;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  white-space: pre;
}

.linkChange:hover {
  border-color: #dadce0;
  box-shadow: rgba(0, 0, 0, .1) 0 1px 1px;
  color: #202124;
}

.linkChange:focus {
  border-color: #4285f4;
  outline: none;
}
  
.no-scrollbar {
    scrollbar-width: none;
    scrollbar-color: transparent transparent;
}
.no-scrollbar::-webkit-scrollbar {
    background: transparent;
}
.no-scrollbar::-webkit-scrollbar-thumb {
    background: transparent;
}
</style>